import React from 'react';
import { Label } from '../ui/label';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../ui/select';
import { EDITABLE_POSTES, BEARERS, bearerTone } from '../../constants/chargePostes';

/**
 * Éditeur de la matrice de prise en charge d'un contrat.
 * Un poste à la charge du client (ou inclus dans le prix prestataire) est exclu
 * de la marge et ne sera pas demandé à la saisie des coûts.
 */
export const ChargeMatrixEditor = ({ value = {}, onChange, disabled = false, compact = false }) => {
  const set = (poste, bearer) => onChange?.({ ...value, [poste]: bearer });

  return (
    <div data-testid="charge-matrix-editor">
      <div className={`grid grid-cols-1 ${compact ? 'md:grid-cols-2' : 'md:grid-cols-3'} gap-3`}>
        <div className="rounded-lg border border-gray-200 bg-gray-50 p-3">
          <p className="text-[11px] uppercase tracking-wider text-gray-500 font-medium">Location camion</p>
          <p className="text-sm font-semibold text-gray-900 mt-1">À notre charge</p>
          <p className="text-[10px] text-gray-500 mt-0.5">
            Cœur du modèle : on loue au prestataire, on revend au client
          </p>
        </div>

        {EDITABLE_POSTES.map((poste) => (
          <div key={poste.key} className="rounded-lg border border-gray-200 p-3">
            <Label className="text-[11px] uppercase tracking-wider text-gray-500 font-medium">
              {poste.label}
            </Label>
            <Select
              value={value[poste.key] || 'na'}
              onValueChange={(v) => set(poste.key, v)}
              disabled={disabled}
            >
              <SelectTrigger
                className={`mt-1 h-9 text-sm ${bearerTone(value[poste.key])}`}
                data-testid={`charge-matrix-${poste.key}`}
              >
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {BEARERS.map((b) => (
                  <SelectItem key={b.key} value={b.key} data-testid={`charge-bearer-${poste.key}-${b.key}`}>
                    {b.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        ))}
      </div>
      <p className="text-[11px] text-gray-500 mt-3">
        Seuls les postes <b>à notre charge</b> entrent dans le calcul de la marge. Les autres ne seront
        ni demandés à la saisie, ni comptés.
      </p>
    </div>
  );
};

export default ChargeMatrixEditor;
